import { ApiError } from './unwrap';

/** The slice of i18next's `t` this helper needs: a key in, a string out. */
type Translate = (key: string) => string;

/**
 * Map a backend {@link ApiError} `code` to its `{prefix}.errors.{code}` i18n
 * message, falling back to `{prefix}.errors.generic` when the error carries no
 * code, the key is untranslated, or the value isn't an `ApiError` at all
 * (ADR 0012). Replaces the per-module `xErrorMessage` duplicates.
 */
export function apiErrorMessage(t: Translate, prefix: string, error: unknown): string {
  if (error instanceof ApiError && error.code) {
    const key = `${prefix}.errors.${error.code}`;
    const translated = t(key);
    if (translated !== key) return translated;
  }
  return t(`${prefix}.errors.generic`);
}
